<!--
 * @Description: 创建、编辑角色
 * @Author: stella
 * @Date: 2021-05-11 14:35:56
 * @LastEditTime: 2021-05-17 10:51:43
 * @LastEditors: stella
-->
<template>
  <el-dialog
    :title="'授权用户'"
    :visible.sync="isAuthDialogVisible"
    :width="'500px'"
    append-to-body
    @close="cancelAddDialogVisible"
  >
    <div class="dialog-body addmember-body">
      <el-form
        label-width="100px"
        class="clearfix"
        ref="ruleForm"
        :model="info"
        :rules="rules"
      >
        <el-form-item label="选择用户：" prop="userIds">
          <el-select
            v-model="info.userIds"
            multiple
            filterable
            remote
            placeholder="请输入登录账号或姓名"
            :remote-method="getUserList"
            :loading="loading"
            :multiple-limit="10"
          >
            <el-option
              v-for="item in userListOption"
              :key="item.userId"
              :label="
                `${item.userName +
                  ' ' +
                  item.loginId +
                  ' ' +
                  (item.teamName ? item.teamName + '团队' : '')}`
              "
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <ul>
        <li>说明:</li>
        <li>1.用户加入到角色之后，才会拥有该角色对应的权限;</li>
        <li>2.单次最多支持10个用户;</li>
      </ul>
    </div>
    <div slot="footer" class="dialog-footer">
      <crm-button
        :buttonType="'plain'"
        :text="'取消'"
        @click="cancelAddDialogVisible"
      >
      </crm-button>
      <crm-button :text="'确定'" @click="handleEdit"></crm-button>
    </div>
  </el-dialog>
</template>
<script>
import service from '~api/backstage';
import crmButton from '@/components/base/crmButton';
import _ from 'lodash';

export default {
  data() {
    var validatorUser = (rule, value, callback) => {
      if (this.flag === 0) return;
      if (value.length === 0) {
        callback(new Error('请输入登录账号或姓名以选择用户'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      info: {
        name: '',
        roleId: '',
        userIds: [],
      },
      flag: 0,
      userListOption: [],
      isAuthDialogVisible: false,
      rules: {
        userIds: [
          {
            // required: true,
            validator: validatorUser,
            trigger: 'change',
          },
        ],
      },
    };
  },
  watch: {
    'info.userIds.length': {
      handler(newval, oldval) {
        if (newval >= 10) {
          this.$message({
            type: 'warning',
            message: '一次最多只能添加10个!',
          });
        }
      },
    },
  },
  components: {
    crmButton,
  },
  methods: {
    // 获取用户列表
    // eslint-disable-next-line
    getUserList: _.debounce(function(query) {
      if (!query) return;
      this.loading = true;
      service
        .apiQueryUser({ searchKeyWord: query })
        .then((res) => {
          this.flag = this.flag + 1;
          this.userListOption = res.data.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    }, 400),
    handleEdit() {
      this.flag = this.flag + 1;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          return this.addAuth();
        }
        return false;
      });
    },
    addAuth() {
      service
        .apiAddRoleUser({
          roleId: this.info.roleId,
          userIds: this.info.userIds,
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '授权用户成功！',
          });
          this.cancelAddDialogVisible();
          this.$emit('refresh');
        });
    },
    cancelAddDialogVisible() {
      this.flag = 0;
      this.isAuthDialogVisible = false;
      this.info = {
        name: '',
        roleId: '',
        userIds: [],
      };
      this.userListOption = [];
      this.resetForm();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
ul {
  margin-left: -10px;
}
ul li {
  margin: 5px 0;
  font-weight: 500;
  font-size: 12px;
  color: #7a84b7;
}
/deep/ .el-select {
  width: 350px;
}
</style>
